module.exports = __webpack_public_path__ + "static/img/product1.8ff9b0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homePage/product1.png
// module id = t6qB
// module chunks = 1